/**
 * Creates a Slide up/down of Content
 * @module fixedOverlay
 */

import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';

export const PLUGIN_NAME = 'fixedOverlay';
export const CLICK_EVENT = 'click';
export const DEFAULTS = {};

/**
 * Initializes an fixedOverlay based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

//export default function fixedOverlay(el, options = {}) {
 export default function fixedOverlay(el, options = {}) {
  var $el = $(el);
  var opts = mergeOptions(DEFAULTS, options, $el)

  applyEventHandlers($el, opts);
}

/**
 * Applies any sort of event handlers for the fixedOverlay.
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

var applyEventHandlers = function($el, opts) {
  opts = opts || {};

  //.js-fixed-overlay
  $el.on(CLICK_EVENT, function(evt){
    showOverlay(evt, $el, opts)
  });

  //.js-fixed-overlay-close
  $el.next('.fixed-overlay__scroll').find('.js-fixed-overlay-close').on(CLICK_EVENT, function() {
    closeOverlay()
  });

};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} opts - Options passed along from initialization
 */

//Activate SlideUp Event
function showOverlay(e, $el) {

  var fixedOverlayScroll = $('.fixed-overlay__scroll');
  var $elOverlayScroll = $el.siblings('.fixed-overlay__scroll');

  //Remove the ability to scroll main content while overlay is present
  $('body').css({'overflow-y': 'hidden'});

  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
  $elOverlayScroll.addClass('fixed-overlay__scroll--active');

}

//Activate SlideDown Event
function closeOverlay() {

  var fixedOverlayScroll = $('.fixed-overlay__scroll');

  //Add back the ability to scroll main content when overlay is closed
  $('body').css({'overflow-y': 'auto'});

  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');

}
registerJQueryPlugin(PLUGIN_NAME, fixedOverlay);



// WEBPACK FOOTER //
// ./src/scripts/modules/fixed-overlay.js